module.exports = __webpack_public_path__ + "fonts/TelefonicaCapWeb-Regular.05b747a5.woff";